import { AiseaApiFactory } from "@/api/aisea/apiFactory";
import * as PlotUtil from "@/utils/PlotUtil";
import { HtmlUtil } from "@/utils";
import { List } from "immutable";

export default {
  async fetchPlots({ commit }, request) {
    let response = await AiseaApiFactory.get("enterprisePlot").search(request);

    commit("SET_PLOTS", response.data.plots);
    commit("SET_PAGING", response.data.pageable);

    return response.data;
  },
  async searchPlots({ commit }, request) {
    let response = await AiseaApiFactory.get("plot").searchByGeoJson(
      request.plotChildCategoryIds,
      request.northEastLatitude,
      request.northEastLongitude,
      request.southWestLatitude,
      request.southWestLongitude
    );

    const features = [];
    if (response.status) {
      for (let key in response.data) {
        let plot = JSON.parse(HtmlUtil.htmlEscape(response.data[key]));
        features.push(PlotUtil.createFeatures(plot));
      }
    }

    commit("SET_FEATURES", features.flat());

    return response.data;
  },
  async getPlot(_, plotId) {
    let res = await AiseaApiFactory.get("plot").get(plotId);

    res.data.plot_points.sort(function(a, b) {
      if (a.sort_order < b.sort_order) return -1;
      if (a.sort_order > b.sort_order) return 1;
      return 0;
    });

    if (res.data.enterprise_id) {
      let pubRes = await AiseaApiFactory.get("enterprisePublic").get(
        res.data.enterprise_id
      );
      res.data["enterprise_public"] = pubRes.data;
    }
    if (res.data.user_id) {
      let pubRes = await AiseaApiFactory.get("userPublic").get(
        res.data.user_id
      );
      res.data.user_public = pubRes.data;
    }

    return res.data;
  },
  async createPlot(_, request) {
    let res = await AiseaApiFactory.get("plot").add(request);

    return res;
  },
  async updatePlot(_, request) {
    let res = await AiseaApiFactory.get("plot").update(request);

    return res;
  },
  async removePlot(_, plotId) {
    let res = await AiseaApiFactory.get("plot").delete(plotId);

    return res;
  },
  async createPlotPicture(_, payload) {
    let formData = new FormData();
    formData.append("data", payload.file);
    let res = await AiseaApiFactory.get("picture").addPlotPicture({
      formData: formData,
    });

    return res.data;
  },
  async removePlotPicture(_, pictureId) {
    let res = await AiseaApiFactory.get("plot").deletePlotPicture(pictureId);

    return res.data;
  },
  async resetPlotState({ commit }) {
    let defaultState = {
      plots: [],
      pageable: {},
      features: List(),
    };
    commit("RESET_STATE", defaultState);
  },
};
